// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RequirePermission } from "@/components/shared/require-permission";
import { UserDetail } from "@/features/iam/user-detail";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/iam/users/$publicId")({
  validateSearch: z.object({ t: z.string().optional(), f: z.string().optional() }),
  component: UserDetailPage,
});

function UserDetailPage() {
  const { publicId } = Route.useParams();
  const { t: tab, f } = Route.useSearch();
  return (
    <RequirePermission permission={PAGE_PERMISSIONS.iamUsers}>
      <UserDetail publicId={publicId} tab={tab} initialFilters={f} />
    </RequirePermission>
  );
}
